export default class IdGenerator {
  constructor() {
    this._id = 0;
  }

  getGeneratorId() {
    return this._id++;
  }
}
